/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Art_History15Inputs */

const en__field_enum_study_art_history15 = /** @type {(inputs: _Field_Enum_Study_Art_History15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Art History`)
};

const de__field_enum_study_art_history15 = /** @type {(inputs: _Field_Enum_Study_Art_History15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunstgeschichte`)
};

/**
* | output |
* | --- |
* | "Art History" |
*
* @param {_Field_Enum_Study_Art_History15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_art_history15 = /** @type {((inputs?: _Field_Enum_Study_Art_History15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Art_History15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_art_history15(inputs)
	return de__field_enum_study_art_history15(inputs)
});
export { _field_enum_study_art_history15 as "_field_enum_STUDY_ART_HISTORY" }